var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0411\\u0435\\u043B\\u044B\\u0435",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 141.7",
    style: {
      enableBackground: "new 0 0 141.7 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.7,71.1c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,0-2.8,0.1-4.2C14.5,33.1,40.8,8.6,72.2,8.6c25.2,0,47.9,15.9,56.5,39.6 c0.5,1.3,0.9,2.6,1.3,3.9c0.4,1.3-0.4,2.7-1.7,3.1c-1.3,0.4-2.7-0.4-3.1-1.7c-0.3-1.2-0.7-2.4-1.2-3.6 c-7.9-21.7-28.7-36.3-51.8-36.3c-28.8,0-52.9,22.5-54.9,51.2c-0.1,1.3-0.1,2.6-0.1,3.8C17.2,70,16.1,71.1,14.7,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,72.7c-0.1,0-0.3,0-0.4,0c-0.9-0.2-1.6-0.8-1.9-1.7L0.6,39.8c-0.5-1.3,0.2-2.7,1.6-3.2c1.3-0.5,2.7,0.2,3.2,1.6 l9.3,27L34,41.4c0.9-1.1,2.5-1.2,3.5-0.4c1.1,0.9,1.2,2.5,0.4,3.5L15.6,71.8C15.1,72.4,14.4,72.7,13.7,72.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3,133c-25.2,0-47.9-15.9-56.5-39.6c-0.5-1.3-0.9-2.6-1.3-3.9c-0.4-1.3,0.4-2.7,1.7-3.1c1.3-0.4,2.7,0.4,3.1,1.7 c0.3,1.2,0.7,2.4,1.2,3.6c7.9,21.7,28.7,36.3,51.8,36.3c28.8,0,52.9-22.5,54.9-51.2c0.1-1.3,0.1-2.6,0.1-3.8c0-1.4,1.1-2.5,2.5-2.5 c1.4,0,2.5,1.1,2.5,2.5s0,2.8-0.1,4.2C128.1,108.5,101.8,133,70.3,133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6,105.1c-1,0-2-0.7-2.4-1.7l-9.3-27l-19.4,23.7c-0.9,1.1-2.5,1.2-3.5,0.4c-1.1-0.9-1.2-2.5-0.4-3.5L127,69.8 c0.6-0.7,1.5-1,2.4-0.9c0.9,0.2,1.6,0.8,1.9,1.7l10.7,31.2c0.5,1.3-0.2,2.7-1.6,3.2C140.2,105.1,139.9,105.1,139.6,105.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.05e80b35b41a885e88d947214ea778fa.svg";
export { ForwardRef as ReactComponent };